import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnVI: CultureInfo = {
  name: 'en-VI',
  displayName: 'English (U.S. Virgin Islands)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-VI',
  parent: CultureInfoEn
};
